import axios from 'axios';
import baseUrl from '@/configs/baseUrl';
const uuid = require("uuid");
export const getUuid = () => {
	return uuid.v4().split("-").join("");
} 
export default {
	getCookie(cname) {
		const name = `${cname}=`;
		const ca = document.cookie.split(';');
		for (let i = 0; i < ca.length; i++) {
			const c = ca[i].trim();
			if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
		}
		return '';
	},
	getQueryString(name) {
		const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
		const r = window.location.search.substr(1).match(reg);
		if (r != null) return unescape(r[2]);
		return null;
	},
	setCookie(cname, cvalue, exdays = 7 * 24 * 60 * 60 * 1000) {
		const d = new Date();
		d.setTime(d.getTime() + exdays);
		const expires = `expires=${d.toGMTString()}`;
		document.cookie = `${cname}=${cvalue}; ${expires}`;
	},
	blobLoadDownLoad(data, fileName) {
		let blob = new Blob([data], {
			type: "application/vnd.ms-excel"
		});
		// FileReader 对象允许Web应用程序异步读取存储在用户计算机上的文件的内容
		const fileReader = new FileReader();
		// 开始读取指定的Blob中的内容。一旦完成，result属性中将包含一个data: URL格式的Base64字符串以表示所读取文件的内容
		fileReader.readAsDataURL(blob);
		fileReader.onload = (event) => {
			// 处理load事件。该事件在读取操作完成时触发
			// 新增个下载的a标签，完成后移除。
			//创建一个a标签
			let a = document.createElement("a");
			//表格名称
			let _fileName = fileName;
			a.download = _fileName;
			a.href = event.target.result;
			document.body.appendChild(a);
			//模拟a标签点击事件
			a.click();
			document.body.removeChild(a);
		}
	},
	downloadFile(url, params = {}, withToken = true, needBaseUrl = true) {
		const token = this.getCookie('authorization');
		const headers = withToken ? {
			'authorization': 'Bearer' + ' ' + token
		} : {};
		url = needBaseUrl ? `${baseUrl}${url}` : url;
		return axios({
			url,
			method: 'GET',
			params,
			responseType: 'blob',
			headers
		});
	},
	downloadBlobFile(blob, filename) {
		const objUrl = window.URL.createObjectURL(blob);
		const a = document.createElement('a');
		if ('download' in a) {
			document.body.appendChild(a);
			a.style.display = 'none';
			a.href = objUrl;
			a.download = filename;
			a.click();
			window.URL.revokeObjectURL(objUrl);
			document.body.removeChild(a);
			return;
		}
		// IE
		navigator.msSaveBlob(blob, filename);
	},
	base64ToBlob(dataurl) {

		const arr = dataurl.split(',');
		const mime = arr[0].match(/:(.*?);/)[1];
		const bstr = atob(arr[1]);
		let n = bstr.length;
		const u8arr = new Uint8Array(n);
		while (n--) {
			u8arr[n] = bstr.charCodeAt(n);
		}
		return new Blob([u8arr], {
			type: mime
		});
	},
	blobToDataURL(blob, callback) {
		let a = new FileReader();
		a.onload = function (e) {
			callback(e.target.result);
		};
		a.readAsDataURL(blob);
	},

};

export function debounce(func, wait, immediate) {
	let timeout, args, context, timestamp, result

	const later = function () {
		// 据上一次触发时间间隔
		const last = +new Date() - timestamp

		// 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
		if (last < wait && last > 0) {
			timeout = setTimeout(later, wait - last)
		} else {
			timeout = null
			// 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
			if (!immediate) {
				result = func.apply(context, args)
				if (!timeout) context = args = null
			}
		}
	}

	return function (...args) {
		context = this
		timestamp = +new Date()
		const callNow = immediate && !timeout
		// 如果延时不存在，重新设定延时
		if (!timeout) timeout = setTimeout(later, wait)
		if (callNow) {
			result = func.apply(context, args)
			context = args = null
		}

		return result
	}
}

export const downloadFileByUrl = (url, fileName) => {
	const elink = document.createElement("a");
	elink.href = url;
	elink.setAttribute("download", fileName);
	elink.style.display = "none";
	document.body.appendChild(elink);
	setTimeout(() => {
		elink.click();
		URL.revokeObjectURL(elink.href);
		document.body.removeChild(elink);
	}, 66);
}

export const htmlParser = (htmlString) => {
	// 创建一个DOMParser对象  
	var parser = new DOMParser();

	// 使用DOMParser的parseFromString方法解析HTML字符串  
	var doc = parser.parseFromString(htmlString, "text/html");

	// 初始化一个变量来保存提取的文本  
	var textContent = '';

	// 遍历文档的body中的所有子节点  
	// 注意：这里我们只处理body中的内容，但你也可以根据需要遍历整个文档  
	var nodes = doc.body.childNodes;
	for (var i = 0; i < nodes.length; i++) {
		// 检查节点是否是文本节点  
		if (nodes[i].nodeType === Node.TEXT_NODE) {
			// 如果是文本节点，则将其内容添加到textContent变量中  
			textContent += nodes[i].nodeValue;
		} else if (nodes[i].nodeType === Node.ELEMENT_NODE) {
			// 如果是元素节点，则递归处理其子节点  
			textContent += getTextContent(nodes[i]);
		}
	}

	// 递归函数用于处理元素节点的子节点  
	function getTextContent(node) {
		var text = '';
		for (var i = 0; i < node.childNodes.length; i++) {
			if (node.childNodes[i].nodeType === Node.TEXT_NODE) {
				text += node.childNodes[i].nodeValue;
			} else if (node.childNodes[i].nodeType === Node.ELEMENT_NODE) {
				text += getTextContent(node.childNodes[i]);
			}
		}
		return text;
	}

	// 去除可能存在的空白字符  
	textContent = textContent.trim();

	// 输出提取的文本  
	return textContent;
}

export const list2tree = (list, field) => {
    let obj = {}
    list.forEach(item => {
        item.children = []
        obj[item][field] = item
    })
	const parentList = [];
	list.forEach((item) => {
	  const parent = obj[item.pid];
	  if (parent) {
		// * 当前项有父节点
		parent.children = parent.children || [];
		delete item.children;
		parent.children.push(item);
	  } else {
		// * 当前项没有父节点 -> 顶层
		parentList.push(item);
	  }
	});
	return parentList;
}

